<div class="content">
    <p>
        Water temperature is generated daily by computer analysis systems using satellite technology. This data is from the Bureau of Meteorology’s Sea Surface Temperature and is unchecked. 
    </p>
</div>

